/**
 * Detection for failed dynamic `import()` calls (chunk 404, network, etc.).
 *
 * What: Classifies an error as a chunk-load failure across browser engines'
 * differing message formats.
 * Why: Lives in its own dependency-free module so the lean marketing boot
 * entry can use it without pulling React (via lazyWithChunkRetry) into its
 * module graph.
 * When: Update when a browser engine introduces a new failure message shape.
 */

/**
 * Returns true if the error is a failed dynamic import (chunk 404, network, etc.).
 * Used to trigger retry or full page reload instead of showing a generic error.
 *
 * @param {Error} error
 * @returns {boolean}
 */
export function isChunkLoadError(error: unknown) {
  const message = error instanceof Error ? error.message : String(error);
  if (typeof message !== 'string') return false;
  const lower = message.toLowerCase();
  return (
    lower.includes('loading chunk') ||
    lower.includes('dynamically imported module') ||
    lower.includes('chunkloaderror') ||
    lower.includes('loading css chunk') ||
    lower.includes('error loading dynamically imported module') ||
    lower.includes('importing a module script failed')
  );
}
